import { render, staticRenderFns } from "./PrizesForm.vue?vue&type=template&id=176766d7&scoped=true&"
import script from "./PrizesForm.vue?vue&type=script&lang=js&"
export * from "./PrizesForm.vue?vue&type=script&lang=js&"
import style0 from "./PrizesForm.vue?vue&type=style&index=0&id=176766d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176766d7",
  null
  
)

export default component.exports